// 🔒 Verrou anti-annulation : le nom du membre doit être tapé à l'identique (vérifié côté serveur → 428 sinon)
export function askConfirmName(action, name) {
  const v = window.prompt(`🔒 VERROU — ${action}\n\nPour confirmer, tape exactement le nom du membre :\n« ${name} »`);
  if (v == null) return null;
  const t = v.trim();
  if (!t) return null;
  return t;
}

export function lockError(e, fallback = "Erreur") {
  const s = e?.response?.status;
  if (s === 428) return "🔒 Nom incorrect — l'action a été refusée (le nom doit être identique à la fiche).";
  if (s === 423) return "🧊 Gel actif — action bloquée tant que le gel de l'incident n'est pas levé.";
  if (s === 409) return e?.response?.data?.detail || "Refusé : paiement récent (< 35 jours) sur cette fiche.";
  return e?.response?.data?.detail || fallback;
}
